import React from 'react'

import { Button, Row, Space, Alert } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

import InvoiceFinances from '../../../../components/job/finance/invoice'
import ClientFinances from '../../../../components/job/finance/client'
import { JOB_STATUS_COMPLETED, JOB_STATUS_DELIVERED } from '../../../../config/const'

const CustomTasksFinances = (props) => {
  return (
    <>
      <Row justify='end'>
        <Space style={{ padding: 10 }}>
          {props.allowEdit && (
            <Button
              size='small'
              icon={<SyncOutlined />}
              onClick={() => props.updatePrices(props.id)}
              disabled={props.actionLoading}
            >
              Prices
            </Button>
          )}
        </Space>
      </Row>

      {props.job.balanceClientStatus === 'Compensated' && (
        <Alert message='This Job has been fully invoiced to the client.' type='success' showIcon />
      )}
      {(props.job.status === JOB_STATUS_COMPLETED || props.job.status === JOB_STATUS_DELIVERED) &&
          props.job.balanceClientStatus === 'Uncompensated' && (
            <Alert message='This Job has not been fully invoiced to the client.' type='warning' showIcon />
      )}
      <InvoiceFinances {...props} />
      <br />
      <br />
      <ClientFinances {...props} client />
    </>
  )
}

export default CustomTasksFinances
